<template>
  <div class="pm-dialog-bit">

    <div class="flex justify-center">
      <div class="flex items-center justify-center pm-dialog-bit-input"
        @mousedown="selectedInput = 0" 
        :class="[
          left ? 'input-any' : 'input-null',
          ( this.selectedInput === 0 ? 'border-selected' : 'border-non-selected' )
        ]"
      >
        <div class="bit-input">
          <span>{{ left }}</span>
        </div>
      </div>
      <div v-show="requiredLeft" class="position-required-left">
        <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8" class="required-option" />
      </div>
      <div class="w-1/12 mt-4 flex items-center justify-center">
        <span>〜</span>
      </div>
      <div class="flex items-center justify-center  pm-dialog-bit-input"
        @mousedown="selectedInput = 1" 
        :class="[
          right ? 'input-any' : 'input-null',
          ( this.selectedInput === 1 ? 'border-selected' : 'border-non-selected' )
        ]"
      >
        <div class="bit-input">
          <span>{{ right }}</span>
        </div>
      </div>
      <div v-show="requiredRight" class="position-required-right">
        <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8"  class="required-option"  />
      </div>
    </div>
    <div class="flex justify-center">
      <div class="vs-row flex justify-start bit-list-width">
        <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" @mousedown="onKeyDown(master.value)">
          <vs-chip color="#828282"
            onMouseOut="this.style.background='#828282'" 
            onMouseOver="this.style.background='#346c88'"
          >
            {{ master.value }}
          </vs-chip>
        </div>
        <div class="vs-col candidate-list"  @mousedown="toggleRequired">
          <vs-chip color="#09151c">
            必須
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end bit-list-width">
        <vs-button 
          class="flex justify-center items-center clear-button"
          color="#828282"
          onMouseOut="this.style.background='#828282'" 
          onMouseOver="this.style.background='#346c88'"
          @mousedown="onClear"
        >クリア</vs-button>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedInput: 0,
      selectedId: -1,
      left: "",
      right: "",
      requiredLeft: false,
      requiredRight: false,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['bit'];
    },
    enableSave() {
      return true; // ( this.left || this.right );
    },
  },
  methods: {
    initData() {

      this.left         = this.valueMap && this.valueMap.left ? this.valueMap.left : "";
      this.requiredLeft = this.valueMap && this.valueMap.left_options ? this.valueMap.left_options.required : false;

      this.right         = this.valueMap && this.valueMap.right ? this.valueMap.right : "";
      this.requiredRight = this.valueMap && this.valueMap.right_options ? this.valueMap.right_options.required : false;

      this.selectedInput = 0;

    },
    onKeyDown(key){
      if ( this.selectedInput !== 1) {
        this.left = this.left ? (this.left + key) : key;
      }
      if ( this.selectedInput === 1) {
        this.right = this.right ? (this.right + key) : key ;
      }
    },
    onClear() {
      if ( this.selectedInput !== 1) {
        this.left = "";
        this.requiredLeft = false;
      }
      if ( this.selectedInput === 1) {
        this.right = "";
        this.requiredRight = false;
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = ["update"];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      let updateKeyValueMap = {};

      updateKeyValueMap[this.columnKey + "#left"] = this.left;
      updateKeyValueMap[this.columnKey + "#left_options"] = {};
      updateKeyValueMap[this.columnKey + "#left_options"]['required'] = this.requiredLeft ? this.requiredLeft : false;

      updateKeyValueMap[this.columnKey + "#right"] = this.right;
      updateKeyValueMap[this.columnKey + "#right_options"] = {};
      updateKeyValueMap[this.columnKey + "#right_options"]['required'] = this.requiredRight ? this.requiredRight : false;

      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
    toggleRequired() {
      if ( this.selectedInput === 0) {
        this.requiredLeft = !this.requiredLeft;
      } else {
        this.requiredRight = !this.requiredRight;
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-bit {
  .pm-dialog-bit-input {
    height: 3rem;
    width: 8rem;
    margin: 1rem;
    padding: 1rem;
    span {
      font-size: 140%;
    }
  }
  .border-selected {
    border: 0.2rem solid $pm-blue;
    border-radius: 4px;
  }
  .border-non-selected {
    border: 0.05rem solid $pm-blue;
    border-radius: 4px;
  }
  .bit-list-width {
    width:84%;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .bit-input {
    margin: 0.4rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .bit-required-item {
    border-radius: 5px;
    font-size: 120%;
    min-width: 2rem;
  }
  .pen-list {
    margin: 0.2rem;
  }
  .pen-item {
    border-radius: 5px;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem ;
  }
  .input-any {
    background-color: $pm-white;
  }
  .input-null {
    background-color: $pm-light-gray;
  }
  .required-option {
    color: $pm-blue;
  }
  .position-required-left {
    position:relative;
    top: -5px;
    left: -15px;
  }
  .position-required-right {
    position:relative;
    top: -5px;
    left: -15px;    
  }
  .clear-button-area {
    width: 70%;
  }
  .clear-button {
    height: 2.8rem;
    margin: 0 0.5rem 1rem 0;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }

}
</style>

